export const FULL_NAME_FIELD = 'name'
export const PASSWORD_FIELD = 'password'
export const PASSWORD_CONFIRM_FIELD = 'confirmPassword'
